var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ejs-menu',{attrs:{"items":_vm.menuItems,"select":_vm.selectItem}})}
var staticRenderFns = []

export { render, staticRenderFns }